<template>
  <ion-page>
    <Header title="Thống kê">
      <ion-toolbar color="light">
        <ion-segment
          @ionChange="segmentChanged($event)"
          value="keno"
          color="light"
        >
          <ion-segment-button value="keno">
            <ion-label>Keno</ion-label>
          </ion-segment-button>
          <ion-segment-button value="power">
            <ion-label>Power</ion-label>
          </ion-segment-button>
          <ion-segment-button value="mega">
            <ion-label>Mega</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </Header>
    <ion-content>
      <template v-if="selectedTab == 'keno'">
        <ion-list>
          <ion-item-group>
            <ion-item
              class="item"
              button
              @click="navigate('/stats/keno/numbers')"
            >
              <ion-label>Bộ số</ion-label>
            </ion-item>
            <ion-item
              class="item"
              button
              @click="navigate('/stats/keno/headtail')"
            >
              <ion-label>Đầu đuôi</ion-label>
            </ion-item>
            <ion-item
              class="item"
              button
              @click="navigate('/stats/keno/oddeven')"
            >
              <ion-label>Chẵn lẻ</ion-label>
            </ion-item>
            <ion-item class="item" button @click="navigate('/stats/keno/hilo')">
              <ion-label>Lớn nhỏ</ion-label>
            </ion-item>
            <ion-item
              class="item"
              button
              @click="goAdvanced"
              v-if="isLoggedIn"
            >
              <ion-label>Thống kê VIP</ion-label>
            </ion-item>
          </ion-item-group>
        </ion-list>
      </template>
      <template v-if="selectedTab == 'power'">
        <PowerStats></PowerStats>
      </template>
      <template v-if="selectedTab == 'mega'">
        <MegaStats></MegaStats>
      </template>
    </ion-content>
    <ion-footer>
      <TabBar select="main"></TabBar>
    </ion-footer>
  </ion-page>
</template>

<style scoped>
.item {
  position: relative;
}
</style>

<script>
import Header from "@/components/Header.vue";
import {
  alertController,
  IonPage,
  IonContent,
  IonItem,
  IonList,
  IonLabel,
  IonItemGroup,
  IonSegment,
  IonSegmentButton,
  IonToolbar,
  IonFooter,
} from "@ionic/vue";
import { useRouter } from "vue-router";
import MegaStats from "@/views/stats/3-Mega.vue";
import PowerStats from "@/views/stats/2-Power.vue";
import TabBar from "@/components/TabBar.vue";
import authService from "@/services/auth";

export default {
  name: "Stats",
  components: {
    MegaStats,
    PowerStats,
    IonContent,
    IonPage,
    IonItem,
    IonList,
    Header,
    IonLabel,
    IonItemGroup,
    IonSegment,
    IonSegmentButton,
    IonToolbar,
    IonFooter,
    TabBar,
  },
  data() {
    return {
      selectedTab: "keno",
    };
  },
  computed: {
    isLoggedIn() {
      // return true;
      return authService.user() && !authService.user().isAnonymous;
    },
  },
  methods: {
    segmentChanged(evt) {
      // console.log(evt.detail.value);
      this.selectedTab = evt.detail.value;
    },
    async goAdvanced() {
      if (this.isLoggedIn) {
        this.$router.push('/stats/keno/advanced')
      } else {
        const alert = await alertController
            .create({
              cssClass: 'my-custom-class',
              header: 'Thông báo',
              subHeader: '',
              message: 'Chỉ có thành viên đã đăng ký hoặc đăng nhập mới có thể sử dụng chức năng này!',
              buttons: [
                {
                  text: 'Đóng',
                  role: 'cancel',
                  handler: err => {
                    console.log('Confirm Cancel:', err)
                  },
                },
              ],
            });
          await alert.present();
      }
    },
  },
  setup() {
    const router = useRouter();
    return {
      router,
      navigate(path) {
        router.push(path);
      },
    };
  },
};
</script>
